import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { text } from '../text';
import { utils } from '../utils';
import { hooks } from '../hooks';
import { svg } from '../assets/svg';
import { theme } from '../constants';
// import { CourseType } from '../types';
import { review as reviews } from '../reviews';
import { ReviewTypes } from '../types/reviewTypes';

type Props = {
  isLast?: boolean;
  review: ReviewTypes;
  status?: 'ongoing' | 'completed';
  section: 'reviews' | 'review' | 'top rated' | 'category list' | 'my courses' | 'Recommanded For you';
};

export const ReviewCard: React.FC<Props> = ({
  review,
  section,
  isLast,
  status,
}) => {
  const navigate = hooks.useNavigate();

  if (section === 'reviews') {
    return (
      <div
        style={{
          width: '100%',
          padding: '0 20px',
          cursor: 'pointer',
          userSelect: 'none',
          ...utils.rowCenter(),
          marginBottom: isLast ? 0 : 10,
          paddingBottom: isLast ? 0 : 10,
          borderBottomWidth: isLast ? 0 : 1,
          borderBottomStyle: isLast ? 'none' : 'solid',
          borderBottomColor: `rgba(59, 89, 153, 0.1)`,
        }}
      // onClick={() => navigate('/course-details', { state: { review } })}
      >
        <div
          style={{
            minWidth: 140,
            minHeight: 110,
            marginRight: 12,
            display: 'flex',
            flexDirection: "column",
            justifyContent: "center",
            gap: 10,
            textAlign: "left",
            alignItems: 'center',
            width: '100%'
            // position: 'relative',
          }}
        >
          <text.T18
            style={{ color: theme.colors.darkTextColor, ...theme.fonts.Lato_700Bold, }}
          >
            {review ? review.title : ""}
          </text.T18>
          <text.T14
            style={{
              color: theme.colors.darkTextColor, lineHeight: 1.3, ...theme.fonts.LeagueSpartan_300Light,
              marginLeft: 30
            }}
          >
            {review ? review.description : ""}
          </text.T14>
          <text.T14
            style={{ color: theme.colors.darkTextColor, ...theme.fonts.Lato_700Bold, }}

          >
            -- {review ? review.name : ""} --
          </text.T14>
        </div>
      </div>
    );
  }
  if (section === 'review') {
    return (
      <div
        style={{
          width: '100%',
          padding: '0 20px',
          cursor: 'pointer',
          userSelect: 'none',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          marginBottom: 10,
          paddingBottom: isLast ? 0 : 10,
          borderBottomWidth: isLast ? 0 : 1,
          borderBottomStyle: isLast ? 'none' : 'solid',
          borderBottomColor: `rgba(59, 89, 153, 0.1)`,
        }}
      // onClick={() => navigate('/course-details', { state: { review } })}
      >
        <div
          style={{
            minWidth: 140,
            minHeight: 110,
            marginRight: 12,
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            textAlign: 'left',
            width: '100%',
          }}
        >
          <text.T18
            style={{
              color: theme.colors.darkTextColor,
              ...theme.fonts.Lato_700Bold,
              textAlign: 'left',
              lineHeight: 1
            }}
          >
            {review ? review?.name : ''}
          </text.T18>
          <text.T14
            style={{
              color: theme.colors.bodyTextColor,
              textAlign: 'left',
            }}
          >
            {/* Working Professional */}
            {review ? review?.title : ''}
          </text.T14>

          <text.T14
            style={{
              color: theme.colors.darkTextColor,
              lineHeight: 1.3,
              ...theme.fonts.LeagueSpartan_300Light,
              textAlign: 'left',
            }}
          >
            {review ? review.description : ''}
          </text.T14>


        </div>
      </div>
    );
  }



  return null;
};
